<ng-container>
  <canvas id="MyChart"></canvas>
</ng-container>
